export default "__VITE_ASSET__CB7lPN1Z__"